module.exports = __webpack_public_path__ + "static/media/40x30.84b7e88c.png";